export function checkAuth(): boolean {
    const authToken = getToken()
    const loggedIn = (authToken && authToken !== '') || false
    return loggedIn
}

export function getToken(): string | null {
    return localStorage.getItem('token')
}

export function setToken(token: string) {
    localStorage.setItem('token', token)
}

export function deleteToken() {
    localStorage.removeItem('token')
}
